import { render, staticRenderFns } from "./FirstAssignmentPage.vue?vue&type=template&id=12642342&scoped=true&"
import script from "./FirstAssignmentPage.vue?vue&type=script&lang=js&"
export * from "./FirstAssignmentPage.vue?vue&type=script&lang=js&"
import style0 from "./FirstAssignmentPage.vue?vue&type=style&index=0&id=12642342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12642342",
  null
  
)

export default component.exports